import { render, staticRenderFns } from "./MultipleColumnsWithImage.vue?vue&type=template&id=02171b14&scoped=true&"
import script from "./MultipleColumnsWithImage.vue?vue&type=script&lang=js&"
export * from "./MultipleColumnsWithImage.vue?vue&type=script&lang=js&"
import style0 from "./MultipleColumnsWithImage.vue?vue&type=style&index=0&id=02171b14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02171b14",
  null
  
)

export default component.exports